import { useEffect, useState} from "react";
import { Box, /*Button,*/ Grid, makeStyles } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { moveNextPage,  updateUserMetrics } from "../../../../../store/actions/creator/creatorExperienceBuilder";
import { apiClient } from "../../../../../config/apiClient";
import CreatorBtn from "../../../../atoms/creator/experienceBuilderEnterBtn";
import UtilService from '../../../../../helper/service';
import {useHistory, useLocation} from "react-router";

const useStyles = makeStyles(() => ({
  subTitle: {
    fontSize: 23,
    fontFamily: 'roboto-bold',
    margin: '25px 0 0',
    color: '#697683'
  },
  subTitle1: {
    fontSize: 23,
    margin: '0',
    fontFamily: 'roboto-bold',
    color: '#697683'
  },
  description: {
    fontSize: 14,
    fontFamily: 'roboto-regular',

  },
  videoClipWrapper:{
    width: 210,
    borderRadius: 20,
    position:'relative',
    marginRight:20,
  },
  videoClip: {
    width: 210,
    height: 135,
    borderRadius: 20,
    background:'#e5e5e5',
  },
  reelSessions:{
    '@media only screen and (min-width: 1820px)': {
      width: '70%'
    },
  },
  remove: {
    position: 'absolute',
    right: -10,
    top: -14,
    '&:hover': {
        cursor: 'pointer'
    }
  },
  description1: {
    font: 'normal normal normal 18px/30px Roboto',
    color:'#697683',
    letterSpacing: '-0.27px',
    maxWidth: '550px'
  },
  boldDescription:{
    fontSize: 18,
    fontFamily: 'roboto-bold',
    color:'#697683',
    letterSpacing: '-0.27px'
  },
  goLiveBtn: {
    width: 144,
    height: 54,
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    fontSize: 19,
    float: 'right',
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
  },
  participantsIcon: {
    width: 24,
    height: 24
  }
}));

function PreReelSessions(props: any) {
  
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { userMetrics, page } = useSelector((state: any) => state.creatorExperienceBuilder);
  const { sessionCode, reelsLastActivePage, createReel, asyncLastActivePage } = userMetrics;

  const [selectedSessions, setSelectedSessions] = useState<any[]>([]);
  const { clickCloseIcon, onRemove, selected } = props;
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";

  useEffect(() => {
    UtilService.addHashTag(history, location.pathname, 'asyncgo');
  }, []);

  useEffect(() => {
    if (selected) {
      setSelectedSessions(selected);
      dispatch(updateUserMetrics('selectedSessions', selected));
    }
  }, [selected]);

  useEffect(() => {
    const getStimulus = async () => {
      const res = await apiClient(true).get(`/stimulus/v2/stimulus/${loginUserData.customer_id}/${sessionCode}`);
      dispatch(updateUserMetrics('stimulusList', res.data))
    };
    getStimulus();
  }, [dispatch, loginUserData.customer_id, sessionCode]);
  
  useEffect(() => {
    window.addEventListener('keydown', handleUserKeyPress);
    return () => {
      window.removeEventListener('keydown', handleUserKeyPress);
    };
  });

  const goNext = () => {
    const nextPage = page + 1;
    dispatch(moveNextPage(nextPage));
    if (createReel) { // create reels from Measure New Experience button
      (nextPage > asyncLastActivePage) && dispatch(updateUserMetrics('asyncLastActivePage', nextPage));
    } else { // create reels from tray modal
      (nextPage > reelsLastActivePage) && dispatch(updateUserMetrics('reelsLastActivePage', nextPage));
    }
  };

  const handleUserKeyPress = (event: any) => {
    if (event.keyCode === 13) {
      goNext();
    }
  };

  const onUploadReelVideo = () => {
    dispatch(updateUserMetrics('reelCanceled', false));
    const prevPage = page - 1;
    dispatch(moveNextPage(prevPage));
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12} md={12}>
        <p className='creator-main-title' style={ createReel ? {marginTop: 60} : {} }>
          {createReel ? 'Check your Reel!' : 'Time to set up your Reel!'}
        </p>
          <p className={classes.boldDescription}>Your reel consists of the following experiences.</p>    
          <Box>
            <Grid container className={classes.description}>
            {(selectedSessions && selectedSessions.length > 0) &&
              selectedSessions.map((sessiondata:any, key:number)=>(
                <Grid item key={key} >
                  <div className={classes.videoClipWrapper}>
                    <img src={sessiondata.img ? sessiondata.img : '/assets/images/placeholder.png'} className={classes.videoClip} key={key} alt={'img'}/>
                    <img onClick={() => onRemove(sessiondata)} src={'/assets/icons/dashboard/remove.svg'} className={classes.remove} alt="{close}" />
                    <p style={{width:'100%', textAlign:"center", marginTop:"0px"}}>{sessiondata.name}</p>
                  </div>
                </Grid>
              ))
            }
            </Grid>
          </Box>
        </Grid>        
        <Grid item md={12} className="mt-30">
          <p className={classes.description1}>We’ll randomize the order of these when shown to your participants, and add time between each video to reset your participants’ emotional response.</p>
        </Grid>
        <Grid item md={12} className="mt-20">
          <p className={classes.boldDescription}>Are the experiences in your reel correct?</p>
        </Grid>
        <Grid item md={12}>
          <div className={classes.reelSessions}>
            <CreatorBtn
              showVideoBtn={createReel}
              type="reel"
              title="Yes"
              goNext={goNext}
              isRight={true}
              closeCreateReel={clickCloseIcon}
              uploadVideo={onUploadReelVideo}
              enableVideoBtn={createReel}
            />
          </div>
        </Grid>
      </Grid>
      
    </>
  )
}

export default PreReelSessions;
